import routes from "../routes";

// Преобразование точечного имени роута в URL-маску по дереву src/routes/index.js.
// 'nodes.index' → '/nodes'; 'devices.index' → '/devices'; нет в дереве → null.
export default class Routes {
    static parseName(name) {
        if (!name) return null;
        const parts = name.split('.');
        let node = routes;
        let url = '';
        for (const part of parts) {
            if (node === null || typeof node !== 'object' || !(part in node)) return null;
            const item = node[part];
            if (typeof item === 'string') {
                // Лист дерева — маска слага; 'index' ('/') ничего не добавляет к URL раздела
                url += (item === '/' ? '' : item);
                node = null;
            } else {
                url += `/${part}`;
                node = item;
            }
        }
        return url === '' ? '/' : url;
    }
}
